var _SettingsManager_config, _SettingsManager_settingsManager;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { settingsFactory, SettingsProvidersType } from '@descomplica/settings-browser';
import { singleton } from 'tsyringe';
let SettingsManager = class SettingsManager {
    constructor() {
        _SettingsManager_config.set(this, void 0);
        _SettingsManager_settingsManager.set(this, void 0);
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _SettingsManager_config, config, "f");
        });
    }
    setUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _SettingsManager_settingsManager, yield settingsFactory.create([SettingsProvidersType.LAUNCHDARKLY], {
                user: {
                    key: user.id,
                    id: user.id,
                    email: user.email,
                    name: user.name,
                },
                clientSideId: __classPrivateFieldGet(this, _SettingsManager_config, "f").settings.launchDarklyClientId,
            }), "f");
        });
    }
    get(settingName, defaultValue) {
        return __classPrivateFieldGet(this, _SettingsManager_settingsManager, "f").get(settingName, defaultValue);
    }
};
_SettingsManager_config = new WeakMap(), _SettingsManager_settingsManager = new WeakMap();
SettingsManager = __decorate([
    singleton()
], SettingsManager);
export { SettingsManager };
